import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { Observable, firstValueFrom, map } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {
  private metaUrl = 'json/meta-data.json';

  constructor(
    private http: HttpClient,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document  // ✅ Angular-safe document

  ) {}

  loadMeta(lang: string): Observable<any> {
    return this.http.get(this.metaUrl).pipe(
      map((data: any) => data[lang] || data['fr'])
    );
  }

  async setMetaData(lang: string): Promise<void> {
    try {
      const meta = await firstValueFrom(this.loadMeta(lang));
      this.titleService.setTitle(meta.title);
      this.metaService.updateTag({ name: 'description', content: meta.description });
      this.metaService.updateTag({ name: 'keywords', content: meta.keywords });
            if (this.document?.documentElement) {
        this.document.documentElement.lang = lang;
      }
    } catch (error) {
      console.error('Error loading meta data:', error);
    }
  }
}
